@if (cfg.appName === "ia") {
  <a class="tile" [class.isMobile]="isMobile()" [class.tablet]="isTablet()">
    @if (sensor()) {
      <i nz-icon nzType="icons:signal" class="mini-svg-icon fillgreen"></i>
    }
    <h4 class="tile-title">{{ sensor()?.sensorDisplayLabel }}</h4>
    <div class="tile-value">
      <span class="tile-data detail">{{
        i18n.langString("installed_by")
      }}</span>
      <span class="tile-data detail-bold">
        {{ sensor()?.installedBy ? sensor()?.installedBy : "-" }}
      </span>
    </div>
  </a>
}
@if (cfg.appName === "em") {
  <a
    class="tile em"
    [class.steamtrap]="isSteamTrap()"
    [class.repair-and-replace]="IsRepairAndReplace()"
    [class.mobile]="isMobile()"
    [class.tablet]="isTablet()"
    [class.warning]="!telemetry()?.inactive && telemetry()?.warning"
    [class.inactive]="telemetry()?.inactive"
    [class.critical]="!telemetry().inactive && telemetry().critical"
  >
    <span class="tile-sensor body-bold">{{
      telemetry()?.sensor?.sensorDisplayLabel
    }}</span>
    @if (
      !telemetry()?.inactive && !telemetry()?.critical && !telemetry()?.warning
    ) {
      <i
        nz-icon
        nzType="icons:status-check"
        class="mini-svg-icon fillgreen"
        [class.fillgreen]="validTimeValue(telemetry()?.Timestamp)"
        [class.fillgrey]="!validTimeValue(telemetry()?.Timestamp)"
      ></i>
    }
    @if (!telemetry()?.inactive && telemetry()?.warning) {
      <i
        nz-icon
        nzType="icons:status-exclamation-octagon"
        class="mini-svg-icon"
      ></i>
    }
    @if (telemetry()?.inactive) {
      <i nz-icon nzType="icons:cross-circle" class="mini-svg-icon"></i>
    }
    @if (!telemetry()?.inactive && telemetry()?.critical) {
      <i
        nz-icon
        nzType="icons:status-exclamation-triangle"
        class="mini-svg-icon"
        [class.fillwhite]="!IsRepairAndReplace()"
        [class.fillred]="IsRepairAndReplace()"
      ></i>
    }
    <div class="tile-value">
      @if (!validTimeValue(telemetry()?.Timestamp)) {
        <ng-container>
          <h4 class="tile-title">{{ i18n.langString("no_data") }}</h4>
        </ng-container>
      }
      @if (validTimeValue(telemetry()?.Timestamp)) {
        <ng-container>
          @if (!isSteamTrapInletOutlet() || !steamtrap_outlet) {
            <ng-container>
              @if (!this.telemetry()?.inactive === true) {
                <h4 class="tile-title">
                  {{ extraParsing(i18n.parse(Title())) }}
                </h4>
              }

              @if (this.telemetry()?.inactive === true) {
                <h4 class="tile-title">
                  {{ i18n.langString("inactive_status") }}
                </h4>
              }
            </ng-container>
          }
          @if (isSteamTrapInletOutlet() && !!steamtrap_outlet) {
            <ng-container>
              <h4 class="tile-title inlet">{{ i18n.langString("inlet") }}</h4>
            </ng-container>
          }
          @if (!isSteamTrap && !isLeakageSensor) {
            <ng-container>
              @if (telemetry()?.valueType === "numerical") {
                <span
                  class="tile-data detail-bold"
                  [class.inlet]="isSteamTrapInletOutlet() && !!steamtrap_outlet"
                  >{{ telemetry()?.value.valStr }}</span
                >
              }
              @if (telemetry()?.valueType === "minmax") {
                <span
                  class="tile-data detail-bold"
                  [class.inlet]="isSteamTrapInletOutlet() && !!steamtrap_outlet"
                  >{{ telemetry()?.value.valStr.min }} -
                  {{ telemetry()?.value.valStr.max }}</span
                >
              }
              @if (telemetry()?.valueType === "boolean") {
                <span
                  class="tile-data detail-bold"
                  [class.inlet]="isSteamTrapInletOutlet() && !!steamtrap_outlet"
                  >{{ i18n.parse(telemetry()?.value.valStr) }}</span
                >
              }
            </ng-container>
          }
          @if (isSteamTrapInletOutlet() && !!steamtrap_outlet) {
            <ng-container>
              <h4 class="tile-title outlet">{{ i18n.langString("outlet") }}</h4>
              @if (telemetry()?.valueType === "numerical") {
                <span class="tile-data outlet detail-bold">{{
                  steamtrap_outlet().value.valStr
                }}</span>
              }
              @if (telemetry()?.valueType === "minmax") {
                <span class="tile-data outlet detail-bold"
                  >{{ steamtrap_outlet().value.valStr.min }} -
                  {{ steamtrap_outlet().value.valStr.max }}</span
                >
              }
              @if (telemetry()?.valueType === "boolean") {
                <span class="tile-data outlet detail-bold">{{
                  i18n.parse(steamtrap_outlet().value.valStr)
                }}</span>
              }
            </ng-container>
          }
        </ng-container>
      }
      @if (validTimeValue(telemetry()?.Timestamp)) {
        <span class="tile-time detail-bold"
          >{{ i18n.langString("ago1") }}{{ minutesToNow(telemetry()?.Timestamp)
          }}{{ i18n.langString("ago2") }}</span
        >
      }
      @if (!validTimeValue(telemetry()?.Timestamp)) {
        <span class="tile-time detail-bold">{{
          i18n.langString("never_checked")
        }}</span>
      }
    </div>
  </a>
}
